import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { Body2, spacing } from 'ui/theme';
import { Checkbox } from 'ui/checkboxV2';
import { FavoriteFilled16 } from 'ui/icons';
import { STARRED_FIELDS } from '../../../constants';

const ListRowWrapper = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: 1fr auto;
  padding: ${pxToRem(2.5)} ${pxToRem(15)};
  &:first-child {
    padding-top: ${pxToRem(5)};
  }
  &:last-child {
    padding-bottom: ${pxToRem(5)};
  }
  margin: ${spacing.half} 0;
`;

type ListRowProps = {
  id: string;
  name: string;
  status: boolean;
  setChecked: () => void;
};

export const FieldsListRow = ({ id, name, status, setChecked }: ListRowProps) => (
  <ListRowWrapper data-test={`export-to-csv-field-${id}`}>
    <Checkbox
      data-test={`checkbox-${id}`}
      id={`checkbox-${id}`}
      status={status}
      label={<Body2>{name}</Body2>}
      setChecked={setChecked}
    />
    {id in STARRED_FIELDS && <FavoriteFilled16 />}
  </ListRowWrapper>
);
